var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "", color: "transparent" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _c("v-tab", { attrs: { href: "#tab-1" } }, [
            _vm._v("Compartir Información")
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        { staticStyle: { padding: "0px" }, attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    "append-icon": "search",
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  on: { input: _vm.onFilterTextBoxChanged },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm6: "",
                md4: _vm.accionCompartir.visible,
                md6: !_vm.accionCompartir.visible
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "15px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionExportar.visible
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { "padding-right": "20px" },
                          attrs: { flat: "", small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.exportar()
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n          "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionCompartir.visible
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-crear",
                          staticStyle: { "padding-right": "0px" },
                          on: {
                            click: function($event) {
                              ;(_vm.editedItem = {}),
                                (_vm.showModalNew = true),
                                (_vm.editedVerDetalle = false)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                "margin-right": "0px",
                                "padding-left": "0px"
                              },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "padding-right": "7px" } },
                            [_vm._v("Compartir")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "auto",
              "font-family": "'Asap', sans-serif"
            },
            attrs: { gridOptions: _vm.gridOptions }
          })
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogDejarCompartir,
          titulo: _vm.$t("mensajes.crud.dejarCompartirInformacion.titulo"),
          mensaje: _vm.$t("mensajes.crud.dejarCompartirInformacion.mensaje", {
            nombre_cliente: _vm.nombreMandante
          }),
          textoBtnSi: _vm.$t(
            "mensajes.crud.dejarCompartirInformacion.btnAceptar"
          ),
          textoBtnNo: _vm.$t(
            "mensajes.crud.dejarCompartirInformacion.btnCancelar"
          )
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.dejarCompartirModalCallback($event)
          }
        }
      }),
      _c("app-nueva-ci", {
        attrs: {
          show: _vm.showModalNew,
          _id: _vm.editedIndex,
          modalEsVerDetalle: _vm.editedVerDetalle
        },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.ciModalCallback($event)
          }
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.dialogIngresarMotivo,
            callback: function($$v) {
              _vm.dialogIngresarMotivo = $$v
            },
            expression: "dialogIngresarMotivo"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogIngresarMotivo = false
                          _vm.motivoDejarCompartirModel = ""
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v("Motivo dejar de compartir información")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n        Favor indique motivo por el cual dejará de compartir información\n        "
                  ),
                  _c("br"),
                  _c("br"),
                  _c(
                    "v-flex",
                    { attrs: { md12: "" } },
                    [
                      _c(
                        "v-form",
                        {
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validFormMotivo,
                            callback: function($$v) {
                              _vm.validFormMotivo = $$v
                            },
                            expression: "validFormMotivo"
                          }
                        },
                        [
                          _c("v-textarea", {
                            attrs: {
                              solo: "",
                              name: "input-7-4",
                              label: "Ingrese motivo... (Opcional)",
                              counter: 500
                            },
                            model: {
                              value: _vm.motivoDejarCompartirModel,
                              callback: function($$v) {
                                _vm.motivoDejarCompartirModel = $$v
                              },
                              expression: "motivoDejarCompartirModel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "white", depressed: "", small: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogIngresarMotivo = false
                          _vm.motivoDejarCompartirModel = ""
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#526da5" } }, [
                        _vm._v("Cancelar")
                      ])
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#526da5", depressed: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.dejarDeCompartir()
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Aceptar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }